import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Sparkles, X, ArrowRight } from "lucide-react";
import { getUTM, captureUTM, track } from "../../lib/tracking";
import { deriveUtmCopy } from "../../lib/utmCopy";

export const UtmBanner = () => {
  const location = useLocation();
  const [copy, setCopy] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    captureUTM();
    const c = deriveUtmCopy({ utm: getUTM(), pathname: location.pathname });
    if (c) {
      track("utm_view", { label: c.badge });
    }
    setCopy(c);

    if (typeof window !== "undefined") {
      setDismissed(
        window.sessionStorage.getItem("equisight_utm_dismissed") === "1"
      );
    }
  }, [location.pathname]);

  if (!copy || dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("equisight_utm_dismissed", "1");
    }
  };

  return (
    <section
      data-testid="utm-banner"
      className="relative overflow-hidden bg-[hsl(var(--sand))]/15"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 px-6 py-5 sm:flex-row sm:items-center sm:justify-between lg:px-10">
        <div className="flex items-start gap-3">
          <span className="mt-0.5 inline-flex items-center gap-1.5 rounded-full bg-[hsl(var(--sand))] px-2.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-[hsl(var(--ink))]">
            <Sparkles className="h-3 w-3" strokeWidth={1.8} />
            {copy.badge}
          </span>
          <div>
            <p className="font-display text-xl text-[hsl(var(--ink))] sm:text-2xl">
              {copy.title}
            </p>
            <p className="mt-1 text-sm text-[hsl(var(--ink-soft))]">
              {copy.offer}
            </p>
          </div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <a
            href="#waitlist"
            data-testid="utm-banner-cta"
            onClick={() =>
              track("cta_click", { label: "utm_banner_cta", page: location.pathname })
            }
            className="inline-flex items-center gap-2 rounded-full bg-[hsl(var(--forest))] px-5 py-2.5 text-sm font-medium text-[hsl(var(--background))] transition-all hover:bg-[hsl(var(--forest-dark))]"
          >
            Claim de deal
            <ArrowRight className="h-4 w-4" strokeWidth={1.8} />
          </a>
          <button
            type="button"
            onClick={dismiss}
            aria-label="Sluit"
            data-testid="utm-banner-close"
            className="rounded-full p-2 text-[hsl(var(--ink-soft))] hover:bg-[hsl(var(--surface))]/60 hover:text-[hsl(var(--ink))]"
          >
            <X className="h-4 w-4" strokeWidth={1.6} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default UtmBanner;
